import React from "react";
import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import '../assets/styles/Main.scss';
import avatar from '../assets/images/avatar.jpeg';
function Main() {

  return (
    <div className="container">
      <div className="about-section">
        <div className="image-wrapper">
          <img src={avatar} alt="Avatar" />
        </div>
        <div className="content">
          <div className="social_icons">
            <a href="https://github.com/K200228" target="_blank" rel="noreferrer"><GitHubIcon /></a>
            <a href="https://www.linkedin.com/in/ismail-ahmed-ansari/" target="_blank" rel="noreferrer"><LinkedInIcon /></a>
          </div>
          <h1>Ismail Ahmed Ansari</h1>
          <p> Software Developer</p>
          <h4><i>ismail.nuces@gmail.com</i></h4>

          <div className="mobile_social_icons">
            <a href="https://github.com/K200228" target="_blank" rel="noreferrer"><GitHubIcon /></a>
            <a href="https://www.linkedin.com/in/ismail-ahmed-ansari/" target="_blank" rel="noreferrer"><LinkedInIcon /></a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Main;